import React from 'react';

/**
 * Map price pin. Rebuilt in Tailwind with the brand tokens (was Material-UI
 * `makeStyles` + `Tooltip` with a hard-coded #03387d).
 *
 * The title uses the native `title` attribute rather than a JS tooltip —
 * inside a Google Maps overlay a portal-based tooltip renders detached from
 * the marker, so the native one is both simpler and better behaved.
 */
const EventPoint = ({ name, price, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    title={name ?? ''}
    className="group relative z-[1000] inline-flex items-center rounded-full border border-white/70 bg-brand-500 px-3 py-1.5 text-xs font-bold text-white shadow-elevated transition-transform duration-150 hover:scale-105 hover:bg-brand-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40"
  >
    <span className="whitespace-nowrap">{price}</span>
    {/* little pointer tail */}
    <span
      aria-hidden
      className="absolute left-1/2 top-full h-2 w-2 -translate-x-1/2 -translate-y-1 rotate-45 border-b border-r border-white/70 bg-brand-500 transition-colors group-hover:bg-brand-600"
    />
  </button>
);

export default EventPoint;
